import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevron-up', 'IconChevronUp', [["path",{"d":"M6 15l6 -6l6 6","key":"svg-0"}]]);